import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import { flowRight as compose } from 'lodash';
import { FormattedMessage, injectIntl } from 'react-intl';
import cx from 'classnames';

// Components
import SeeAll from '../SeeAll';
import HomeSlider from '../HomeSlider';
// Skeleton Loader
import Shimmer from '../../Skeleton/Shimmer';
import HomeSliderSkleton from '../../Skeleton/HomeSliderSkleton';
// GraphQL
import { getRecommendQuery } from '../../../lib/graphql';
import { withQuery } from '../../../hoc/withGraphql';
// Locale
import messages from '../../../locale/jsonMessages';
import s from './RecommendListing.css';
import l from '../../Skeleton/Skeleton.css';

const RecommendListing = ({ getRecommendData: { loading, getRecommend = [] }, skeletonArray }) => {
  if (loading) {
    return (
      <div className={s.pageContainer}>
        <div className={s.container}>
          <div className={cx(l.popularSkeletonTitle)}>
            <Shimmer />
          </div>
          <div className='fourCardSkeleton'>
            {[1, 2, 3, 4].map((n) => (
              <HomeSliderSkleton key={n} />
            ))}
          </div>
        </div>
      </div>
    );
  }

  if (!getRecommend.length) return null;

  return (
    <div className={s.recommandBg}>
      <div className={s.container}>
        <div>
          <h3 className={s.containerTitle}>
            <FormattedMessage {...messages.recommended} />
          </h3>
          <HomeSlider data={getRecommend} paginationNextClass="recommendedSwiperNavigationNextBtn" paginationPrevClass="recommendedSwiperNavigationPrevBtn" />
          <SeeAll />
        </div>
      </div>
    </div>
  );
};

RecommendListing.propTypes = {
  getRecommendData: PropTypes.shape({
    loading: PropTypes.bool,
    getRecommend: PropTypes.array
  }),
  skeletonArray: PropTypes.array.isRequired
};

RecommendListing.defaultProps = {
  getRecommendData: {
    loading: true
  }
};

export default compose(
  injectIntl,
  withStyles(s, l),
  withQuery(getRecommendQuery, {
    name: 'getRecommendData',
    options: {
      ssr: false,
      fetchPolicy: 'network-only'
    }
  })
)(RecommendListing);
